import html2canvas from "html2canvas";

const getPrintableHead = (extraStyles = "") => {
  const pageStyles = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style'),
  )
    .map((node) => node.outerHTML)
    .join("\n");

  return `
    ${pageStyles}
    <style>
      html, body {
        margin: 0;
        padding: 0;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .no-print {
        display: none !important;
      }

      ${extraStyles}
    </style>
  `;
};

const waitForPrintWindowImages = (printWindow) => {
  const images = Array.from(printWindow.document.images || []);

  if (!images.length) return Promise.resolve();

  return Promise.all(
    images.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }

          const done = () => resolve();
          img.addEventListener("load", done, { once: true });
          img.addEventListener("error", done, { once: true });
        }),
    ),
  );
};
export const PrintPage = (data = [], title = "") => {
  if (!Array.isArray(data) || data.length === 0) return;

  const addData = data.map((report, index) => ({
    SN: index + 1,
    ...report,
  }));

  const headers = Object.keys(addData[0]);

  const tableTitle = `
    <h2 style="text-align: center; margin: 15px;">
      ${title}
    </h2>
  `;

  const tableHTML = `
    <table>
      <thead>
        <tr>
          ${headers?.map((h) => `<th>${h}</th>`).join("")}
        </tr>
      </thead>
      <tbody>
        ${addData
          .map(
            (row) => `
              <tr>
                ${headers?.map((key) => `<td>${row?.[key] ?? ""}</td>`).join("")}
              </tr>
            `,
          )
          .join("")}
      </tbody>
    </table>
  `;

  const win = window.open("", "_blank");

  if (!win) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  win.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title || "Print Report"}</title>

        <style>
          body {
            padding: 10px;
            color: black;
            font-weight: 500;
            font-family: Arial, sans-serif;
          }

          h2 {
            margin: 0 0 15px 0;
            color:black;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 10px;
          }

          th,
          td {
            border: 1px solid black;
            padding: 4px;
            text-align: left;
          }

          th {
            background: #f2f2f2;
            font-weight: bold;
          }
        </style>
      </head>

      <body>
        ${tableTitle}
        ${tableHTML}
      </body>
    </html>
  `);

  win.document.close();

  win.onload = () => {
    setTimeout(() => {
      win.focus();
      win.print();
      win.close();
    }, 300);
  };
};
export const printImg = async (id, name) => {
  const invoiceElement = document.getElementById(id);
  if (!invoiceElement) return;

  await new Promise((resolve) => setTimeout(resolve, 1000));

  const canvas = await html2canvas(invoiceElement, {
    scale: 2,
    useCORS: true,
    allowTaint: false,
    logging: false,
  });
  const dataUrl = canvas.toDataURL("image/png");

  const printWindow = window.open("", "_blank");
  printWindow.document.write(`
      <html>
        <head>
          <title>${name}</title>
        </head>
        <body style="margin:0; display:flex; justify-content:center; align-items:flex-start;">
        <img src="${dataUrl}" style="width:100%; height:auto; object-fit:contain;"/>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = window.close;
            }
          </script>
        </body>
      </html>
    `);
  printWindow.document.close();
};

export const printElement = async (id, styles = "", scale = 1) => {
  const element = document.getElementById(id);
  if (!element) return;

  const content = element.outerHTML;

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        ${getPrintableHead(`  @page {
          } body { zoom:${scale}; }\n${styles}`)}
      </head>

      <body>
        <div class="print-area">
          ${content}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.onload = async () => {
    await waitForPrintWindowImages(printWindow);
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };
};

export const printElementV2 = async (id, styles = "", scale = 1) => {
  const element = document.getElementById(id);
  if (!element) return;

  const content = element.outerHTML;

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        />
        <style>
          @page {
            size: horizontal;
            margin: 5mm;
          }

          @media print {
            html, body {
              width: 297mm;
              min-height: 210mm;
            }
          }

          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
          }

          .card {
            border: none !important;
            box-shadow: none !important;
            page-break-after: always;
          }

          .card:last-child {
            page-break-after: auto;
          }

          .row {
            display: flex;
            flex-wrap: wrap;
          }

          table {
            table-layout: fixed;
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            font-size: 10px !important;
            line-height: 1.1 !important;
            padding: 1px 2px !important;
            word-wrap: break-word;
            white-space: normal !important;
            vertical-align: top;
          }

          h3 {
            font-size: 14px !important;
            margin: 0 0 2px 0 !important;
          }

          h4 {
            font-size: 11px !important;
            margin: 0 !important;
          }

          small {
            font-size: 14px !important;
            line-height: 1.1 !important;
          }

          .text-nowrap {
            white-space: normal !important;
          }

          .card-body {
            padding: 4px !important;
          }

          ${styles}
        </style>
      </head>

      <body>
        <div class="print-area">
          ${content}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.onload = async () => {
    await waitForPrintWindowImages(printWindow);
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };
};

const CERT_STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Lora:ital,wght@0,400;0,500;1,400&family=Inter:wght@500;600&display=swap");

* { box-sizing: border-box; }
html, body {
  margin: 0;
  padding: 0;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.cc-outer {
  background: #faf6ec;
  padding: 10px;
  border: 2px solid #a9812e;
  width: 210mm;
  min-height: 290mm;
  margin: 0 auto;
  position: relative;
}
.cc-inner {
  border: 1.5px solid #16233f;
  padding: 46px 56px 40px;
  position: relative;
  min-height: calc(290mm - 24px); /* was: min-height: 100%;  — 24px = cc-outer's 10px padding + 2px border, doubled */
  background: radial-gradient(circle at 50% 42%, rgba(169, 129, 46, 0.06), transparent 55%);
}
.cc-inner::before {
  content: "";
  position: absolute;
  top: 55%; left: 50%;
  transform: translate(-50%, -50%);
  width: 280px; height: 280px;
  background-image: var(--cc-logo-url);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}
.cc-inner > * { position: relative; z-index: 1; }

.cc-corner { position: absolute; width: 34px; height: 34px; z-index: 2; }
.cc-corner-tl { top: 10px; left: 10px; border-top: 2px solid #a9812e; border-left: 2px solid #a9812e; }
.cc-corner-tr { top: 10px; right: 10px; border-top: 2px solid #a9812e; border-right: 2px solid #a9812e; }
.cc-corner-bl { bottom: 10px; left: 10px; border-bottom: 2px solid #a9812e; border-left: 2px solid #a9812e; }
.cc-corner-br { bottom: 10px; right: 10px; border-bottom: 2px solid #a9812e; border-right: 2px solid #a9812e; }
.cc-corner::after { content: ""; position: absolute; width: 6px; height: 6px; border-radius: 50%; background: #6b1b2e; }
.cc-corner-tl::after { top: -3px; left: -3px; }
.cc-corner-tr::after { top: -3px; right: -3px; }
.cc-corner-bl::after { bottom: -3px; left: -3px; }
.cc-corner-br::after { bottom: -3px; right: -3px; }

.cc-header {
  display: grid;
  grid-template-columns: 100px 1fr 100px;
  align-items: center;
  gap: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid #a9812e;
}
.cc-logo-box { display: flex; justify-content: center; }
.cc-logo-box img { width: 100px; height: 100px; object-fit: contain; }
.cc-header-text { text-align: center; }
.cc-inst-name {
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  font-size: 30px;
  color: #16233f;
  letter-spacing: 1px;
  margin: 0;
  text-transform: uppercase;
}
.cc-inst-meta { font-family: "Inter", sans-serif; font-size: 11.5px; color: #5b5f6b; margin: 3px 0 0; letter-spacing: 0.3px; }

.cc-title-block { text-align: center; margin: 34px 0 30px; }
.cc-eyebrow { font-family: "Inter", sans-serif; font-size: 11px; letter-spacing: 3px; color: #a9812e; text-transform: uppercase; margin: 0 0 6px; }
.cc-title { font-family: "Cormorant Garamond", serif; font-weight: 700; font-size: 40px; letter-spacing: 6px; color: #16233f; margin: 0; text-transform: uppercase; }
.cc-title-rule { display: flex; align-items: center; justify-content: center; gap: 10px; margin-top: 12px; }
.cc-title-rule .line { width: 70px; height: 1px; background: #a9812e; }
.cc-title-rule .dot { width: 6px; height: 6px; transform: rotate(45deg); background: #6b1b2e; }

.cc-meta-row { display: flex; justify-content: space-between; font-family: "Inter", sans-serif; font-size: 12px; color: #5b5f6b; margin-bottom: 26px; }

.cc-body { font-family: "Lora", serif; font-size: 16.5px; line-height: 2.1; color: #26314a; text-align: justify; }
.cc-body p { margin: 0 0 14px; }

.cc-blank {
  display: inline-block;
  padding: 0 4px;
  font-family: "Lora", serif;
  font-size: 16.5px;
  font-style: italic;
  color: #16233f;
  line-height: 1.3;
  vertical-align: baseline;
  /* border-bottom removed — no underline under filled-in fields */
}

.cc-footer { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 60px; padding-top: 10px; }
.cc-footer-col { font-family: "Inter", sans-serif; font-size: 12px; color: #5b5f6b; }
.cc-footer-col .cc-line {
  border-top: 1px solid #16233f;
  padding-top: 6px;
  margin-top: 30px;
  min-width: 170px;
  text-align: center;
  color: #16233f;
  font-weight: 600;
}
`;

const escCert = (val) =>
  String(val ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ],
  );

const buildManualCertificateMarkup = (form, setting, logoUrl) => `
  <div class="cc-outer" style="--cc-logo-url: url('${logoUrl}')">
    <div class="cc-inner">
      <div class="cc-corner cc-corner-tl"></div>
      <div class="cc-corner cc-corner-tr"></div>
      <div class="cc-corner cc-corner-bl"></div>
      <div class="cc-corner cc-corner-br"></div>

      <div class="cc-header">
        <div class="cc-logo-box"><img src="${logoUrl}" alt="logo" /></div>
        <div class="cc-header-text">
          <h1 class="cc-inst-name">${escCert(setting?.name)}</h1>
          <p class="cc-inst-meta">
            ${escCert(setting?.village)}, ${escCert(setting?.district)}, ${escCert(setting?.state)} - ${escCert(setting?.pin_code)}
          </p>
          <p class="cc-inst-meta">
            Mobile: ${escCert(setting?.mobile)}${setting?.secondary_mobile ? `, ${escCert(setting.secondary_mobile)}` : ""}
            &nbsp;&bull;&nbsp; ${escCert(setting?.email)}
          </p>
        </div>
      </div>

      <div class="cc-title-block">
        <p class="cc-eyebrow">This certifies that</p>
        <h2 class="cc-title">Character Certificate</h2>
        <div class="cc-title-rule"><span class="line"></span><span class="dot"></span><span class="line"></span></div>
      </div>

      <div class="cc-meta-row">
        <div>Certificate No: <span class="cc-blank">${escCert(form.cert_no)}</span></div>
        <div>Date of Issue: <span class="cc-blank">${escCert(form.date)}</span></div>
      </div>

      <div class="cc-body">
        <p>
          This is to certify that Mr./Ms. <span class="cc-blank">${escCert(form.name)}</span>
          ${escCert(form.relation)} <span class="cc-blank">${escCert(form.parent_name)}</span>
          was a bonafide student of <b>${escCert(setting?.name)}</b>, bearing Registration No.
          <span class="cc-blank">${escCert(form.reg_no)}</span>.
        </p>
        <p>
          He/She studied in <span class="cc-blank">${escCert(form.course)}</span> course during the
          academic session <span class="cc-blank">${escCert(form.session)}</span>.
        </p>
        <p>
          During his/her stay in the institute, his/her conduct and character were found to be
          <span class="cc-blank">${escCert(form.conduct)}</span>. We wish him/her success and a bright future ahead.
        </p>
      </div>

      <div class="cc-footer">
        <div class="cc-footer-col">
          <div style="margin-top:6px;">Place: ${escCert(form.place)}</div>
        </div>
        <div class="cc-footer-col">
          <div class="cc-line">Principal Seal &amp; Signature</div>
        </div>
      </div>
    </div>
  </div>
`;

/**
 * Print the manual Character Certificate from live form/setting state
 * (not from the on-screen DOM), so typed input values always show up.
 */
export const printManualCertificate = (form, setting, imgBaseUrl) => {
  const logoUrl = setting?.logo_img ? `${imgBaseUrl}${setting.logo_img}` : "";
  const markup = buildManualCertificateMarkup(form, setting, logoUrl);

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Character Certificate</title>
        <style>${CERT_STYLES}</style>
      </head>
      <body>
        ${markup}
      </body>
    </html>
  `);
  printWindow.document.close();

  const img = printWindow.document.querySelector("img");
  const imgReady =
    !img || img.complete
      ? Promise.resolve()
      : new Promise((resolve) => {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
  const fontsReady = printWindow.document.fonts?.ready ?? Promise.resolve();

  Promise.all([imgReady, fontsReady]).then(() => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 200);
  });
};

const PRINT_PROFILES = {
  timetable: `
    @page {
      size: A4 landscape;
      margin: 7mm;
    }

    html,
    body {
      width: 100% !important;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      color: #222 !important;
      font-family: Arial, sans-serif !important;
      font-size: 10px !important;
    }

    .no-print,
    .timetable-page .no-print {
      display: none !important;
    }

    .timetable-page {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #222 !important;
      background: #fff !important;
    }

    .timetable-page .tt-panel {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      overflow: visible !important;
      break-after: auto !important;
      page-break-after: auto !important;
    }

    .timetable-page .tt-panel-header {
      padding: 0 0 8px !important;
      border-bottom: 1px solid #bbb !important;
    }

    .timetable-page .tt-heading {
      font-size: 16px !important;
      line-height: 1.25 !important;
      margin: 0 !important;
      color: #222 !important;
    }

    .timetable-page .tt-subtitle {
      font-size: 10px !important;
      margin-top: 3px !important;
      color: #555 !important;
    }

    .timetable-page .tt-summary {
      gap: 5px !important;
    }

    .timetable-page .tt-summary-item {
      padding: 4px 6px !important;
      font-size: 9px !important;
      background: #fff !important;
      border: 1px solid #ccc !important;
      color: #222 !important;
    }

    .timetable-page .tt-table-wrap {
      width: 100% !important;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
    }

    .timetable-page .tt-table {
      width: 100% !important;
      min-width: 0 !important;
      table-layout: fixed !important;
      border-collapse: collapse !important;
      border-spacing: 0 !important;
      margin: 0 !important;
      font-size: 9px !important;
    }

    .timetable-page .tt-table th,
    .timetable-page .tt-table td {
      position: static !important;
      min-width: 0 !important;
      height: auto !important;
      padding: 5px !important;
      border: 1px solid #b9c0ca !important;
      vertical-align: top !important;
      white-space: normal !important;
      overflow-wrap: anywhere !important;
      word-break: normal !important;
      line-height: 1.3 !important;
      color: #222 !important;
    }

    .timetable-page .tt-table thead th {
      background: #edf1f8 !important;
      text-align: center !important;
      vertical-align: middle !important;
    }

    .timetable-page .tt-table .tt-batch-heading,
    .timetable-page .tt-table tbody .tt-batch-cell {
      position: static !important;
      width: 15% !important;
      min-width: 0 !important;
      background: #f5f6f8 !important;
    }

    .timetable-page .tt-period-number {
      width: 20px !important;
      height: 20px !important;
      margin-bottom: 3px !important;
      font-size: 9px !important;
      background: #e6ebf8 !important;
    }

    .timetable-page .tt-period-name {
      font-size: 10px !important;
      line-height: 1.25 !important;
      margin-bottom: 3px !important;
    }

    .timetable-page .tt-period-time {
      font-size: 8px !important;
      white-space: normal !important;
      color: #444 !important;
    }

    .timetable-page .tt-batch-name {
      font-size: 10px !important;
      line-height: 1.3 !important;
      overflow-wrap: anywhere !important;
    }

    .timetable-page .tt-batch-label {
      font-size: 8px !important;
      color: #555 !important;
    }

    .timetable-page .tt-class-card {
      height: auto !important;
      min-height: 0 !important;
      padding: 5px !important;
      border: 1px solid #d1d7e2 !important;
      border-left: 2px solid #3659c9 !important;
      border-radius: 3px !important;
      background: #f7f8fc !important;
      break-inside: avoid;
      page-break-inside: avoid;
    }

    .timetable-page .tt-subject {
      font-size: 9px !important;
      line-height: 1.3 !important;
      margin-bottom: 4px !important;
      font-weight: 700 !important;
      color: #222 !important;
    }

    .timetable-page .tt-teacher {
      font-size: 8px !important;
      line-height: 1.3 !important;
      color: #444 !important;
    }

    .timetable-page .tt-teacher i,
    .timetable-page .tt-subject i {
      color: #3659c9 !important;
    }

    .timetable-page .tt-free {
      height: auto !important;
      min-height: 0 !important;
      padding: 5px 2px !important;
      border: 1px dashed #ccc !important;
      border-radius: 3px !important;
      background: #fafafa !important;
      font-size: 8px !important;
      color: #555 !important;
    }

    .timetable-page .tt-entry-separator {
      margin-top: 5px !important;
      padding-top: 5px !important;
    }

    .timetable-page .card-body {
      padding: 0 !important;
    }

    .timetable-page .tt-panel > .border-top {
      margin-top: 6px !important;
      padding: 6px 0 0 !important;
      border-top: 1px solid #ccc !important;
    }

    .timetable-page .tt-panel > .border-top span {
      font-size: 9px !important;
    }

    .timetable-page .tt-empty {
      padding: 15px !important;
    }

    .timetable-page .tt-table thead {
      display: table-header-group;
    }

    .timetable-page .tt-table tbody tr {
      break-inside: avoid;
      page-break-inside: avoid;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      box-sizing: border-box !important;
    }
  `,
};

/**
 * Copies the current page styles into the new print window.
 * Stylesheet links are converted to absolute URLs.
 */
const getPrintWindowStyles = () =>
  Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
    .map((node) => {
      if (node.tagName === "LINK") {
        return `<link rel="stylesheet" href="${node.href}">`;
      }

      return node.outerHTML;
    })
    .join("\n");

/**
 * Shared print engine.
 *
 * Legacy usage remains supported:
 * printElementV2("PrintDiv", "", 0.6);
 *
 * Profile usage:
 * printElementV2("PrintDiv", {
 *   profile: "timetable",
 *   title: "Monday Timetable",
 *   pageSize: "A4",
 *   orientation: "landscape",
 * });
 */
export const printWithProfile = async (
  id,
  stylesOrOptions = "",
  legacyScale = 1,
) => {
  const element = document.getElementById(id);

  if (!element) {
    console.error(`Print element not found: ${id}`);
    return;
  }

  const isOptionsObject =
    stylesOrOptions !== null &&
    typeof stylesOrOptions === "object" &&
    !Array.isArray(stylesOrOptions);

  const options = isOptionsObject
    ? stylesOrOptions
    : {
        styles: stylesOrOptions,
        scale: legacyScale,
        profile: "default",
      };

  const {
    profile = "default",
    title = "Print",
    pageSize = "A4",
    orientation = "portrait",
    margin = "7mm",
    styles = "",
    scale = 1,
  } = options;

  const profileStyles = PRINT_PROFILES[profile] || "";

  if (profile && profile !== "default" && !PRINT_PROFILES[profile]) {
    console.warn(
      `Unknown print profile "${profile}". Using default print styling.`,
    );
  }

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Wrap the timetable so its existing .timetable-page CSS selectors work.
  const content =
    profile === "timetable"
      ? `<div class="timetable-page">${element.outerHTML}</div>`
      : element.outerHTML;

  const pageRule = `
    @page {
      size: ${pageSize} ${orientation};
      margin: ${margin};
    }
  `;

  const baseStyles = `
    * {
      box-sizing: border-box;
    }

    html,
    body {
      margin: 0;
      padding: 0;
      background: #fff;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    body {
      color: #222;
      font-family: Arial, sans-serif;
    }

    .no-print {
      display: none !important;
    }

    .print-area {
      width: 100%;
      margin: 0;
      padding: 0;
    }

    ${profile === "default" ? `body { zoom: ${scale}; }` : ""}

    ${pageRule}
    ${profileStyles}
    ${styles}
  `;

  printWindow.document.open();

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>${String(title).replace(/[<>&"]/g, "")}</title>

        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        />

        ${getPrintWindowStyles()}

        <style>
          ${baseStyles}
        </style>
      </head>

      <body>
        <div class="print-area">
          ${content}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();

  const runPrint = async () => {
    try {
      await waitForPrintWindowImages(printWindow);

      if (printWindow.document.fonts?.ready) {
        await printWindow.document.fonts.ready;
      }

      // Allow external stylesheets to finish applying before printing.
      await new Promise((resolve) => setTimeout(resolve, 300));

      printWindow.focus();
      printWindow.print();
    } catch (error) {
      console.error("Unable to print:", error);
    }
  };

  if (printWindow.document.readyState === "complete") {
    runPrint();
  } else {
    printWindow.addEventListener("load", runPrint, { once: true });
  }

  // Close after the user finishes or cancels printing.
  printWindow.addEventListener(
    "afterprint",
    () => {
      printWindow.close();
    },
    { once: true },
  );
};
